<template>
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <div class="page-header-top-container">
                <div class="page-name">Draggable Benefits</div>
                <!--<button type="submit" v-on:click.prevent="addDayforceDoc" class="btn btn-primary waves-effect pull-right">Add</button>-->
                <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 pull-right">
                    <v-select v-model="locationId"
                              name="locationId"
                              id="locationId"
                              label="text"
                              :clearable="false"
                              :searchable="false"
                              :filterable="false"
                              :options="locationArr"
                              placeholder="Select State">
                    </v-select>
                </div>
            </div>
            <!--page content-->
            <div class="admin-page-content">
                <form id="benefitForm">
                    <div class="">
                        <draggable v-model="draggableBenefitsList" v-on:change="changePosition()" class="drag-view">
                            <template v-for="(text, index) in draggableBenefitsList">
                                <div :key="index" class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-20">
                                    <div class="card">
                                        <div class="card-body">
                                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                                <h2 class="text-muted display-4 text-danger">
                                                    <strong>
                                                        <small class="text-danger">{{text.type_name}} - {{text.provider_name}}</small>
                                                    </strong>
                                                </h2>
                                                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                                    <div class="form-group">
                                                        {{text.location_name}}
                                                    </div>
                                                    <div class="form-group" v-html="text.phone"></div>
                                                    <div class="form-group">
                                                        <p v-html="text.url" v-linkified:options="{ className: 'internal-link' }" v-linkified></p>
                                                        <!-- <a class="internal-link" target="_blank" :href="'mailto: + text.url'"></a> -->
                                                    </div>
                                                </div>
                                            </div>

                                            <!--<div class="col-md-12 col-sm-12 col-xs-12">
                                                <button class="btn btn-danger pull-right"  v-on:click.prevent="deleteDayforceDocSection(text.id)"><i class="fa fa-trash" aria-hidden="true"></i></button>
                                            </div>-->
                                            <!--End Button Section-->
                                            <div class="clearfix"></div>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </draggable>
                    </div>
                </form>
            </div>
            <!--page content-->
        </div>
        <app-backend-footer></app-backend-footer>
    </div>
</template>

<script>
    import $ from 'jquery';
    import vSelect from 'vue-select';
    import BackendFooter from '@/components/backend/partials/Footer';
    import draggable from 'vuedraggable';
    import Vue from "vue";
    import SessioMixin from '../../../mixins/sessionmixin';
    import {HTTP} from '../../../http-common';
    var self;
    export default {
        name: 'ListDraggableBenefits',
        mixins: [SessioMixin],
        components: {
            draggable,
            'v-select': vSelect,
            'app-backend-footer': BackendFooter,
        },
        data() {
            return {
                locationArr: [],
                locationId: '',
                draggableBenefitsList: [],
            }
        },
        computed: {
        },
        beforeMount: function () {
            self = this;
            self.checkLogin();
        },
        mounted: function () {
            self.showLoader();
            self.MenuClose();
            self.loadLocations();
        },
        watch: {
            locationId: function (locationType) {
                self.getDraggableBenefitsData();
            },
        },
        methods: {
            loadLocations() {
                HTTP.post("getlocation")
                        .then(function (response) {
                            /*self.locationArr = response.data.content;*/
                            $.each(response.data.content, function (i) {
                                if (response.data.content[i].value != 0) {
                                    if (i == 1) {
                                        self.locationId = {
                                            value: response.data.content[i].value,
                                            text: response.data.content[i].text,
                                        };
                                    }
                                    self.locationArr.push(response.data.content[i]);
                                }
                            });
                            self.getDraggableBenefitsData();
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                            }
                        });
            },
            getDraggableBenefitsData: function() {
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };
                var fields = {
                    locationId: self.locationId.value,
                };
                self.showLoader();
                HTTP.post("/getdraggablebenefitsdata", fields, config)
                        .then(function (response) {
                            self.draggableBenefitsList = response.data.content;
                            self.hideLoader();
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    //EventBus.$emit("logged-in", true, "", "");
                                    self.$router.push("/login");
                                }
                                self.error = err.response.data.message;
                            }
                            self.hideLoader();
                        });
            },
            changePosition() {
                var fields = {
                    draggableBenefitsList: self.draggableBenefitsList,
                    locationId: self.locationId.value,
                };
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };
                HTTP.post("/changepositiondraggablebenefits", fields, config)
                        .then(function (response) {
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    //EventBus.$emit("logged-in", true, "", "");
                                    self.$router.push("/login");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/backend/benefits/ListDraggableBenefits.vue